import PlusIcon from 'assets/icons/plus';
import { IconButton } from '@mui/material';

const AddIconButton = ({ onClick, disabled = false, sx = {} }) => {
	return (
		<IconButton sx={{ padding: 0, cursor: 'pointer', width: '34px', height: '34px', ...sx }} onClick={onClick} disabled={disabled}>
			<PlusIcon color="#1890ff" width="20px" height="20px" />
		</IconButton>
	);
};

export default AddIconButton;
